/**
 * @generated SignedSource<<7b637ffcb0e08eddc4ae6c6ce804392c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner$data = {
  readonly key: string;
  readonly " $fragmentSpreads": FragmentRefs<"entrypointContext_issueNavigatorActionConditionalFormatting_ConditionalFormattingEntrypointProvider">;
  readonly " $fragmentType": "container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner";
};
export type container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner$key = {
  readonly " $data"?: container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner$data;
  readonly " $fragmentSpreads": FragmentRefs<"container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "name": "container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "kind": "FragmentSpread",
      "name": "entrypointContext_issueNavigatorActionConditionalFormatting_ConditionalFormattingEntrypointProvider"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "5fb1babc3ffe013540ee86e7cec73956";

export default node;
